import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Alert
} from '@mui/material';
import { addContactMessage } from '../../services/AdditionalFirestoreService';

const Contact: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState<{type: 'success' | 'error', message: string} | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name || !email || !subject || !message) {
      setAlert({ type: 'error', message: 'Lütfen tüm alanları doldurun.' });
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setAlert({ type: 'error', message: 'Lütfen geçerli bir e-posta adresi girin.' });
      return;
    }

    try {
      setLoading(true);
      await addContactMessage({
        name,
        email,
        subject,
        message
      });

      setAlert({ type: 'success', message: 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.' });
      setName('');
      setEmail('');
      setSubject('');
      setMessage('');
    } catch (error) {
      console.error('Error sending contact message:', error);
      setAlert({ type: 'error', message: 'Mesaj gönderme sırasında bir hata oluştu. Lütfen tekrar deneyin.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        İletişim
      </Typography>

      {alert && (
        <Alert
          severity={alert.type}
          sx={{ mb: 2 }}
          onClose={() => setAlert(null)}
        >
          {alert.message}
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 4 }}>
        <TextField
          fullWidth
          label="Adınız"
          value={name}
          onChange={(e) => setName(e.target.value)}
          margin="normal"
          required
        />

        <TextField
          fullWidth
          label="E-posta"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          margin="normal"
          required
        />

        <TextField
          fullWidth
          label="Konu"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          margin="normal"
          required
        />

        <TextField
          fullWidth
          label="Mesajınız"
          multiline
          rows={6}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          margin="normal"
          required
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          sx={{ mt: 3 }}
          disabled={loading}
        >
          {loading ? 'Gönderiliyor...' : 'Mesaj Gönder'}
        </Button>
      </Box>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          İletişim Bilgileri
        </Typography>
        <Typography variant="body1" gutterBottom>
          Telefon: +90 555 555 55 55
        </Typography>
        <Typography variant="body1" gutterBottom>
          E-posta: info@rolyef.com
        </Typography>
        <Typography variant="body1" gutterBottom>
          Adres: İstanbul, Türkiye
        </Typography>
      </Box>
    </Container>
  );
};

export default Contact;